import React from 'react';
import loadable from '@loadable/component';

import myProfileQuery from './me.graphql';

export const MyProfile = loadable(
  () => import(/* webpackChunkName: "profile" */ './views/my-profile')
);

// Fixes loadable type errors `Property 'graphQL' does not exist on type`

const MyProfilePage = () => {
  return <MyProfile />;
};

type Variables = {
  offset: string | number;
  section: string;
};

MyProfilePage.variables = ({ offset = 0 }: Variables) => {
  return {
    offset: typeof offset === 'string' ? parseInt(offset, 10) : offset,
  };
};

MyProfilePage.group = ({
  name,
  variables,
}: {
  name: string;
  variables: Variables;
}) => {
  const groupVariables = variables
    ? Object.keys(variables)
        .filter(key => key === 'offset')
        .filter(key => variables[key])
        .map(key => variables[key])
    : [];

  return `${name}_${groupVariables.join('_')}`;
};

MyProfilePage.graphQL = myProfileQuery;

export default MyProfilePage;
